var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./SkeletonSmall.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-68ef929c\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SkeletonSmall.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Skeleton/SkeletonSmall/SkeletonSmall.vue.html
// module id = Z7Fk
// module chunks = 2